import {DataTypeBuilder} from './dataTypeBuilder';

export class DateTimePickerDataTypeBuilder extends DataTypeBuilder {
  timeFormat: string;

  constructor() {
    super();
    this.editorAlias = 'Umbraco.DateTimeUnspecified';
    this.editorUiAlias = 'Umb.PropertyEditorUi.DateTimePicker';
  }

  withTimeFormat(timeFormat: string) {
    this.timeFormat = timeFormat;
    return this;
  }

  getValues() {
    let values: any = [];
    values.push({
      alias: 'timeFormat',
      value: this.timeFormat || 'HH:mm'
    });
    return values;
  }
}